module.exports = __webpack_public_path__ + "static/media/AprendizDoSucessoCentralizadoBranco.62baf22b.png";